import './modules/register-service-worker';
import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';

/*
* Functionalities that are needed in unicef main site and in unicef walk
*/

import stickyHeader from './modules/sticky-header';
import MegaMenuDropdowns from './modules/megamenu-dropdowns';
import handleDetailClosing from './modules/handleDetailClosing';
import BalanceText from './modules/balance-text'
import Accordion from './modules/accordion';
import MailingListForm from './modules/mailing-list-form';
import vhCalculation from './modules/vh-calculation';

export function core(){
  //header functionality
  stickyHeader();

  const megamenuDropdowns = new MegaMenuDropdowns(document.querySelector('.header'), {bodyClass: 'megamenu-open'});
  megamenuDropdowns.init();

  // init simple video players
  const videoContainers = document.querySelectorAll('.js-video-container');
  if (videoContainers.length) {
    import('./modules/initSimpleVideoPlayer')
      .then(({default: initSimpleVideoPlayer}) => {
        videoContainers.forEach(container => {
          initSimpleVideoPlayer(container, '.js-video-control')
        })
      })
  }

  const accordions = document.querySelectorAll('.js-accordion');
  accordions.forEach(el => {
    new Accordion(el, {
      allowMultipleOpen: el.getAttribute('data-allow-multiple-open') === 'true'
    });
  });

  // Init physics clusters
  const physicsClusterElements = document.querySelectorAll('.js-item-cluster');
  if (physicsClusterElements.length) {
    import('./modules/physics-cluster')
      .then(({ default: PhysicsCluster }) => {
        physicsClusterElements.forEach(element => {
          const cluster = new PhysicsCluster(element);

          // No need for explicit resize or reposition calls,
          // as PhysicsCluster handles this dynamically
        });
      });
  }

  // Init dialogs
  const dialogElements = document.querySelectorAll('.js-dialog');
  if (dialogElements.length) {
    import('./modules/dialog').then(({ default: Dialog }) => {
      //console.log('Dialog module loaded successfully');

      // Initialize each dialog
      dialogElements.forEach((dialogElement) => {
        const dialogInstance = new Dialog(dialogElement);

        // Find all triggers for this dialog
        const dialogId = dialogElement.getAttribute('id');
        const triggers = document.querySelectorAll(`[data-open-dialog="${dialogId}"]`);

        triggers.forEach((trigger) => {
          //console.log('Binding trigger:', trigger);
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            //console.log(`Opening dialog for: ${dialogId}`);
            dialogInstance.open();
          });
        });
      });
    });
  }

  //init link wrappers, to make whole lift areas clickable
  const linkWrappersElements = document.querySelectorAll('.js-link-wrapper');
  if (linkWrappersElements.length) {
    import('./modules/link-wrappers')
      .then(({default: LinkWrappers}) => {
        const linkWrappers = new LinkWrappers(linkWrappersElements);
        linkWrappers.attachListeners();
      })
  }


  //knowledge test
  handleDetailClosing('.js-knowledge-test');

  // Init balancedText
  const balanceText = new BalanceText()
  balanceText.init()

  //Donation landing forms
  const donationLandingForms = document.querySelectorAll('.js-donation-preform');
  if (donationLandingForms.length) {
    import('./modules/donation-preform')
      .then(({default: DonationPreform}) => {
        donationLandingForms.forEach(container => {
          const form = new DonationPreform(container, {});
          form.init();
        })
      })
  }

  // See https://www.npmjs.com/package/@crasman/branch-bar for settings
  branchBar.init();

  // Asynchronous functionality
  (async () => {

    // Initialize form functionality
    if (document.querySelectorAll('.js-form').length > 0) {

      // Load custom select module dynamically
      const {default: Form} = await import('./modules/form');
      const {default: FormAjax} = await import('./modules/form-ajax');

      // Get all forms with js-form , except donation forms (initialised seperately)
      const forms = document.querySelectorAll('.js-form:not(.js-donation__form)');

      // Initialize each form
      forms.forEach(formElement => {
        if(formElement.hasAttribute('data-ajax-url')) {
          const form = new FormAjax(formElement);
          form.init();
        } else {
          const form = new Form(formElement);
          form.init();
        }
      });
    }

    // Initialize custom selects
    const customSelectContainer = '.js-form__cell.form__cell-type--dropdown, .js-custom-select-container';
    if (document.querySelectorAll(customSelectContainer).length > 0) {

      // Load custom multiselect dynamically
      const {default: CustomMultiselect} = await import('./modules/custom-multiselect');

      // Loop selects and initialize multiselect for each element
      document.querySelectorAll(customSelectContainer).forEach(multiselect => {

        // Create multiselect
        const customMultiselect = new CustomMultiselect(multiselect,
          // Function after initialization
          function() {
            this.replacePart('.multiselect__option');
            this.replacePart('.multiselect__button');
          },
          // Multiselect part templates
          {
            '.multiselect__option': '<span>{{contents}}</span><i class="icon icon--check icon--check-circle"><svg aria-hidden="true" width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00016 11.1698L1.83016 6.99984L0.410156 8.40984L6.00016 13.9998L18.0002 1.99984L16.5902 0.589844L6.00016 11.1698Z"/></svg></i>',
            '.multiselect__button': '{{contents}}<i class="icon icon--caret-down icon--caret-down"><svg aria-hidden="true" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.4425 0.442383L5 3.87738L1.5575 0.442383L0.5 1.49988L5 5.99988L9.5 1.49988L8.4425 0.442383Z" fill="black"/></svg></i>',
          },
          // Use BEM
          true
        );

        // Initialize custom multiselects
        customMultiselect.init();
      });
    }

    //select search
    const searchSelectElements = document.querySelectorAll('.js-init-select-search');
    if (searchSelectElements.length) {
      import('./modules/select-search')
        .then(({default: selectSearch}) => {
          searchSelectElements.forEach(select => {
            selectSearch.initSingle(select);
          });

        })
    }

    const mailingListForm = document.querySelectorAll('.js-mailing-list-form');
    if (mailingListForm.length > 0) {
      mailingListForm.forEach(form => {
        new MailingListForm(form);
      });
    }
  })();

  //Cookiebot related
  import('./modules/cookiebot-helper').then(({default: CookieBotHelper}) => {
    const cookiebotHelper = new CookieBotHelper();
    cookiebotHelper.initCustomWidgetOpeners('[data-open-cookiebot]');
    cookiebotHelper.addConsentListeners();
  });

  const carouselElements = document.querySelectorAll('.js-carousel');
  if (carouselElements.length) {
    import('./modules/carousel')
      .then(({default: Carousel}) => {
        carouselElements.forEach(carouselElement => {
          const carousel = new Carousel(carouselElement);
          carousel.init();
        })
      })
  }
  const sliderElements = document.querySelectorAll('.js-slider');
  if (sliderElements.length) {
    import('./modules/slider')
      .then(({default: Slider}) => {
        sliderElements.forEach(sliderElement => {
          const slider = new Slider(sliderElement);
          slider.init();
        })
      })
  }

  //activate viewport height unit calculation
  vhCalculation();
}

const pollSections = document.querySelectorAll('.js-poll-section');
if (pollSections.length) {
  import('./modules/poll')
    .then(({default: Poll}) => {
      pollSections.forEach(section => {
        const pollSection = new Poll(section);
        pollSection.init();
      })
    })
}

const scrollElements = document.querySelectorAll('.js-scrollable');
if (scrollElements.length) {
  import('./modules/scrollable')
    .then(({default: Scrollable}) => {
      scrollElements.forEach(scrollElement => {
        const scrollable = new Scrollable(scrollElement);
        scrollable.init();
      })
    })
}

const quizzes = document.querySelectorAll('.js-quiz');
if (quizzes.length) {
  import('./modules/quiz')
    .then(({default: Quiz}) => {
      quizzes.forEach(quizElement => {
        const quiz = new Quiz(quizElement);
        quiz.init();
      })
    })
}

const animatedCounterElemens = document.querySelectorAll('.js-animated-counter');
if (animatedCounterElemens.length) {
  import('./modules/animated-counter')
    .then(({default: AnimatedCounter}) => {
      animatedCounterElemens.forEach(counterElement => {
        const animatedCounter = new AnimatedCounter(counterElement);
        animatedCounter.init();
      })
    })
}

const elementsToAnimate = document.querySelectorAll('.js-animate, .editor-image--wider-width, .editor-image--full-width');
if (elementsToAnimate.length) {
  import('./modules/animate-on-view-enter')
    .then(({default: animateOnViewEnter}) => animateOnViewEnter(elementsToAnimate))
}

window.addEventListener('CookiebotOnLoad', function () {
  document.body.classList.add('cookiebot-ready');
});
